import { useGetPayLinkByPayLinkId } from '../../../api/lending/lapiHooks';
import { useQueryParam } from '../../../hooks/useQueryParam';

export function useCurrentPayLink() {
  const payLinkId = useQueryParam('payLinkId') || undefined;

  return useGetPayLinkByPayLinkId({ payLinkId });
}
